// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table[data-v-1c3eab58] {\n  border-spacing: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
